import apiClient from './api'

export interface NotifySellerVehicleCaptureData {
  tipo: string
  vehicleType: string
  year: string
  brand: string
  subBrand: string
  version: string
}

export interface NotifySellerVehicleCaptureResponse {
  success: boolean
  sellerFound: boolean
  sent: boolean
  sentCount: number
}

export const vehicleCaptureService = {
  /**
   * Notifica (push) al vendedor asignado al cliente para que capture
   * manualmente el vehículo solicitado. Nunca lanza error de negocio —
   * siempre responde 200; el "éxito" real se lee de sellerFound/sent.
   */
  notifySellerVehicleCapture: async (
    data: NotifySellerVehicleCaptureData
  ): Promise<NotifySellerVehicleCaptureResponse> => {
    const response = await apiClient.post(
      '/credit-application/notify-seller-vehicle-capture',
      data
    )
    return response.data.data
  },
}

export default vehicleCaptureService
